import { Anchor, Flex, Text } from '@mantine/core';
import { NavLink } from 'react-router';

type CompanyBreadcrumbsProps = {
  subPage: string;
};

export const CompanyBreadcrumbs = ({ subPage }: CompanyBreadcrumbsProps) => (
  <Flex gap={4} wrap='nowrap'>
    <Anchor to='/company-list' component={NavLink} variant='gray'>
      Компании
    </Anchor>
    <Text>/</Text>
    <Text c='tertiary.4' truncate='end' maw='50dvw'>
      {subPage}
    </Text>
  </Flex>
);
